
import * as XLSX from "xlsx";

export const parseExcel = async (filePath, wineColor, language = 'FR') => {
  try {
    const response = await fetch(filePath);
    if (!response.ok) {
      throw new Error("Échec de la récupération du fichier. Vérifiez le chemin d'accès.");
    }

    const data = await response.arrayBuffer();
    const workbook = XLSX.read(data, { type: "array" });

    const sheetName = wineColor.toUpperCase(); // Par exemple, "ROUGE"
    const worksheet = workbook.Sheets[sheetName];

    if (!worksheet) {
      throw new Error(`La feuille ${sheetName} n'existe pas dans le fichier Excel.`);
    }

    const jsonData = XLSX.utils.sheet_to_json(worksheet);

    // Extraction des données avec les nouvelles colonnes de légende
    const timelineData = jsonData.map((row) => ({
      year: row["YEAR"],
      trigram: row["TRIGRAMME"],
      legendReussite: row[`LEGEND_${language.toUpperCase()}_REUSSITE`] || "",    // Colonne C
      legendEvolution: row[`LEGEND_${language.toUpperCase()}_EVOLUTION`] || "",  // Colonne D
      legendPuissance: row[`LEGEND_${language.toUpperCase()}_PUISSANCE`] || "",  // Colonne E
    })).filter(item => item.trigram);

    return timelineData;
  } catch (error) {
    console.error("Erreur lors de la lecture du fichier Excel :", error);
    return [];
  }
};
